import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import { tween, easing } from 'popmotion';
import { interpolate } from 'flubber';
import styles from './blobMorpher.css';

const paths = {
  one:
    'M202.869042,916.827339 C339.761798,916.827339 401.733349,543.970474 479.867071,441.848662 C536.322656,368.060463 873.946822,292.908982 873.946822,192.082667 C873.946822,-48.2858275 703.118016,5.0359998 467.313287,5.0359998 C231.508557,5.0359998 1.79870927,116.068495 1.79870927,356.436989 C1.79870927,596.805483 -32.9356867,916.827339 202.869042,916.827339 Z',
  two:
    'M164.828291,917 C331.287078,917 581.160928,769.064037 676.169934,644.932544 C744.81877,555.241232 858,377.079146 858,254.52236 C858,-37.6512643 736.195798,1.7815295 449.462077,1.7815295 C162.728356,1.7815295 52.581768,69.5418755 52.581768,361.7155 C52.581768,653.889124 -121.90543,917 164.828291,917 Z',
  three:
    'M198.828291,917 C365.287078,917 460.765869,649.459223 555.774875,525.32773 C624.42371,435.636418 892,377.079146 892,254.52236 C892,-37.6512643 626.804262,-108.958335 475.308339,208.184698 C323.812415,525.32773 20.3541308,133.630481 20.3541308,425.804105 C20.3541308,717.977729 -87.9054303,917 198.828291,917 Z',
};

const pathIds = Object.keys(paths);

// Changed to a transition factory function, which accepts
// a duration and returns a transition function
const morphTransition = duration => ({ from, to }) =>
  tween({
    from: 0,
    to: 1,
    duration,
    ease: easing.easeInOut,
  }).pipe(interpolate(from, to));

const Blob = posed.path(
  pathIds.reduce((config, id) => {
    config[id] = {
      d: paths[id],
      // Passes duration as prop to transition factory function
      transition: ({ duration }) => morphTransition(duration),
    };

    return config;
  }, {}),
);

class BlobMorpher extends Component {
  state = { pathIndex: 0 };

  componentDidMount() {
    this.gotoNext();
    // Updated this to use duration for internal, but can be static too
    this.interval = setInterval(this.gotoNext, this.props.duration);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  gotoNext = () => {
    const { pathIndex } = this.state;
    const nextIndex = pathIndex + 1;
    this.setState({
      pathIndex: nextIndex > pathIds.length - 1 ? 0 : nextIndex,
    });
  };

  render() {
    return (
      <Fragment>
        <svg
          fill={`${this.props.color}`}
          width="100%"
          height="100%"
          viewBox="0 0 900 917"
          className={styles.blob}>
          <Blob pose={pathIds[this.state.pathIndex]} duration={this.props.duration} />
        </svg>
      </Fragment>
    );
  }
}

BlobMorpher.defaultProps = {
  color: 'var(--green)',
  duration: 1000,
};

BlobMorpher.propTypes = {
  color: PropTypes.string,
  duration: PropTypes.number,
};

export default BlobMorpher;
